'use client'

import { useState } from 'react'
import { usePalette } from '@/contexts/PaletteContext'
import { palettes } from '@/lib/palettes'

export function PaletteSwitcher() {
  const { paletteName, setPalette, paletteNames } = usePalette()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Toggle button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-12 h-12 rounded-full shadow-lg flex items-center justify-center transition-transform hover:scale-105"
        style={{ background: 'var(--accent-primary)' }}
        title="Switch palette"
      >
        <svg
          className="w-6 h-6 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
          />
        </svg>
      </button>

      {/* Palette menu */}
      {isOpen && (
        <div className="absolute bottom-16 right-0 w-72 bg-card rounded-2xl shadow-2xl border border-border overflow-hidden">
          <div className="p-4 border-b border-border-subtle">
            <h3 className="font-medium text-sm">Rothko Palettes</h3>
            <p className="text-text-tertiary text-xs mt-1">
              Click to switch the color scheme
            </p>
          </div>
          <div className="p-2 max-h-80 overflow-y-auto">
            {paletteNames.map((name) => {
              const palette = palettes[name]
              const isActive = name === paletteName

              return (
                <button
                  key={name}
                  onClick={() => {
                    setPalette(name)
                    setIsOpen(false)
                  }}
                  className={`w-full flex items-center gap-3 p-3 rounded-xl transition-colors ${
                    isActive ? 'bg-page' : 'hover:bg-page/50'
                  }`}
                >
                  {/* Color preview */}
                  <div className="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0 border border-border-subtle">
                    <div
                      className="w-full h-1/2"
                      style={{ background: palette.hero.topField[1] }}
                    />
                    <div
                      className="w-full h-1/2"
                      style={{ background: palette.hero.bottomField[0] }}
                    />
                  </div>

                  {/* Info */}
                  <div className="text-left flex-1 min-w-0">
                    <p className={`text-sm font-medium ${isActive ? 'text-text-primary' : 'text-text-secondary'}`}>
                      {palette.name}
                    </p>
                    <p className="text-xs text-text-tertiary truncate">
                      {palette.painting}
                    </p>
                  </div>

                  {/* Active indicator */}
                  {isActive && (
                    <div
                      className="w-2 h-2 rounded-full"
                      style={{ background: 'var(--accent-primary)' }}
                    />
                  )}
                </button>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}
